import React from "react";

const attributeValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const AttributeSelectionPanel = ({ onSelection }) => {
    return (
        <div className="attribute-selection-panel">
            {attributeValues.map(value => (
                <div className={`attribute-indicator`} onClick={() => onSelection(value)}>
                    <div className={`attribute-indicator__value attribute-indicator--${value}`}>{value}</div>
                </div>
            ))}
        </div>
    );
}

export default AttributeSelectionPanel;
